import React, { ReactHTML } from 'react';
import ReactDOM from 'react-dom';
import './PrePaySelectorCSS.css';
import moment from 'moment';
import DatePicker from "react-datepicker";

export interface PrePaySelectorState {
    startDate: Date | null | undefined;
    endDate: Date | null | undefined;
    startValue: string;
    endValue: string;
    fStartDate: string;
    fStartTime: string;
    fEndDate: string;
    fEndTime: string;
    fPromoCode: string | number | string[] | undefined;
}

export interface PrePaySelectorProps {

}

export default class PrePaySelectorComponent extends React.Component<PrePaySelectorProps, PrePaySelectorState> {

    state: PrePaySelectorState;
    r: HTMLFormElement | null;
    constructor(props: PrePaySelectorProps) {
        super(props);
        this.r = null;
        let sp = new URLSearchParams(window.location.search);
        
        this.state = {
            fPromoCode: (sp.has("promo") ? sp.get("promo")! : '')!,
            startDate: null,
            endDate: null,
            startValue: '',
            endValue: '',
            fStartDate: '',
            fStartTime: '',
            fEndDate: '',
            fEndTime: '',
            
        }
        sp.delete('promo');

    }

    filterStartDate = (date: Date) => {
        let m = moment(date);
        if (moment().subtract("d",1).isAfter(m)) {
            return false;
        }
        if (this.state.endDate !== null) {
            if (moment(this.state.endDate).isBefore(m)) {
                return false;
            }
            return true;
        }
        return true;
    };
    filterEndDate = (date: Date) => {
        let m = moment(date);
        if (moment().subtract("d",1).isAfter(m)) {
            return false;
        }
        if (this.state.startDate !== null) {
            if (moment(this.state.startDate).isAfter(m)) {
                return false;
            }
            return true;
        }
        return true;
    };

    handleStartDateChange = (date: Date) => {
        let m = moment(date);


        this.setState(Object.assign(this.state, {
            startDate: date,
            arrivalError: null,
            startValue: m.format('MM/DD/YYYY h:mm A'),
            fStartDate: m.format('DDMMYYYY'),
            fStartTime: m.format('HHmm')
        }))
    };

    handleEndDateChange = (date: Date) => {
        let m = moment(date);
        this.setState(Object.assign(this.state, {
            endDate: date,
            arrivalError: null,
            endValue: m.format('MM/DD/YYYY h:mm A'),
            fEndDate: m.format('DDMMYYYY'),
            fEndTime: m.format('HHmm')
        }))
    };

    handlePromoChange = (value: string) => {
        this.setState(Object.assign(this.state, {fPromoCode: value}));
    }

    checkAvailability = () => {
        if (this.r !== null) {
            this.r.submit();
        }
    };

    render() {
        console.log(this.state.fPromoCode)
        return (
            <div className="d-flex flex-column h-100" style={{ background: 'rgba(133, 27, 29, 0.7)' }}>
                <div className="px-3" style={{ color: 'white', fontFamily: 'Calibri, sans-serif', fontSize: '1.9em', fontWeight: 'bold', paddingTop: '0.5em', lineHeight: 1 }}>Sky Harbor Discount Parking</div>
                <div style={{ color: 'white', fontSize: '1.2em', fontWeight: 'bold', paddingBottom: '10px' }}>Book Your Parking</div>
                {/* https://onlineparking.skyharbor.aero/PhoenixBooking/Booking/SearchParking */}
                <form name="frm1" ref={(r) => this.r = r} id="frm1" action="https://onlineparking.skyharbor.aero/PhoenixBooking/Booking/SearchParking" method="post" style={{ display: 'none' }}>
                    <input type="hidden" name="start_date" id="start_date" value={this.state.fStartDate} onChange={() => { }} />
                    <input type="hidden" name="start_time" id="start_time" value={this.state.fStartTime} onChange={() => { }} />
                    <input type="hidden" name="end_date" id="end_date" value={this.state.fEndDate} onChange={() => { }} />
                    <input type="hidden" name="end_time" id="end_time" value={this.state.fEndTime} onChange={() => { }} />
                    <input type="hidden" name="promo_code" id="promo_code" value={this.state.fPromoCode} onChange={() => { }} />
                </form>
                <form className="d-flex flex-column justify-content-center" style={{ height: '50%' }}>

                    <div className="form-row px-3 mb-2">

                        <div className="col">

                            <DatePicker className={"db form-control"}
                                onChange={this.handleStartDateChange}
                                selected={this.state.startDate}
                                value={this.state.startValue !== '' ? this.state.startValue : ''}
                                withPortal
                                showTimeSelect
                                filterDate={this.filterStartDate}
                                timeFormat="p"
                                timeIntervals={30}
                                placeholderText={"Start Date and Time"}
                                dateFormat="MMMM d, yyyy h:mm aa" />
                        </div>
                    </div>

                    <div className="form-row px-3 mb-2">
                        <div className="col">
                            <DatePicker className={"db form-control"}
                                onChange={this.handleEndDateChange}
                                selected={this.state.endDate}
                                value={this.state.endValue !== '' ? this.state.endValue : ''}
                                withPortal
                                showTimeSelect
                                filterDate={this.filterEndDate}
                                timeFormat="p"
                                timeIntervals={30}
                                placeholderText={"End Date and Time"}
                                dateFormat="MMMM d, yyyy h:mm aa" />
                        </div>
                        
                    </div>
                    <div className="form-group px-3">
                        <input type="text" className="form-control" placeholder="Promo Code" value={this.state.fPromoCode} onChange={(e) => this.handlePromoChange(e.target.value)}/>
                    </div>
                    <a className="btn ppdp-box-md" onClick={this.checkAvailability}>BOOK NOW</a>
                </form>

            </div>
        );
    }
}

let domContainer = document.querySelector('#pppcm');
if (!(domContainer === undefined || domContainer === null)) ReactDOM.render(<PrePaySelectorComponent />, domContainer);
let domContainer2 = document.querySelector('#pppcs');
if (!(domContainer === undefined || domContainer === null)) ReactDOM.render(<PrePaySelectorComponent />, domContainer2);